module.exports = __webpack_public_path__ + "img/C000020.51632480.png";